/**
 * Scroll Reveal Animation Module
 * Observes elements with the `.reveal` class and triggers visibility on enter.
 * Gracefully respects prefers-reduced-motion.
 */

export function initScrollReveal() {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const revealElements = document.querySelectorAll('.reveal');

  if (revealElements.length === 0) return;

  if (prefersReducedMotion || !('IntersectionObserver' in window)) {
    // If user prefers reduced motion or observer is unsupported, make all elements immediately visible
    revealElements.forEach((el) => el.classList.add('visible'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.08,
      rootMargin: '0px 0px -40px 0px'
    }
  );

  revealElements.forEach((el) => observer.observe(el));
}

